module.exports = __webpack_public_path__ + "static/open-source-test-6d8dac50cadf7c7bf14d9909d0af976e.jpg";